export const getCategorySeoNameByLevel = (level) => {
    if (level >= 3) {
        return window.clientData?.displayAds?.config?.targeting[`l${level}`];
    } else {
        return window.clientData?.displayAds?.config[`l${level}Category`];
    }
};
